<div [ngClass]="{ 'choose-date-wrapper': isDisplayWrapper, 'choose-date-read-only': readOnly }">
  <div class="choose-date" (click)="calendarOpen()">
    <div class="date">
      <ng-container *ngIf="date; else notSet">
        <span *ngIf="!isEraFormatJpDate" class="header-dt">{{ date | date : 'yyyy年MM月dd日' }}</span>
        <span *ngIf="isEraFormatJpDate" class="header-dt">{{ date | formatJPDateEra }}</span>
        <span *ngIf="showDateOfWeek" class="header-dow day-of-week"
              [ngClass]="{ saturday: date.getDay() === 6, sunday: date.getDay() === 0 }">（{{ date | date : 'EEEEE' : undefined : 'ja-JP' }}）
        </span>
      </ng-container>
      <ng-template #notSet>
        <span class="header-dt not-set">{{ notSetText }}</span>
      </ng-template>
    </div>
    <mat-icon class="d-flex choose-date-icon" svgIcon="calendar" aria-hidden="false"></mat-icon>
  </div>
</div>
